export default {
  'menu.workbench': '工作台',
  'menu.home': '首页',
  'menu.login': '登录',
  'menu.settings': '系统设置',
  'menu.settings.permissions': '权限管理',
  'menu.settings.modelSettings': '模型设置',

  // EDI 交换中心 7 大一级与 21 页面导航
  'menu.dashboard': '运行看板',

  'menu.access': '接入管理',
  'menu.access.partners': '交易伙伴',
  'menu.access.partnerDetail': '伙伴详情',
  'menu.access.partnerTestReport': '联调测试报告',
  'menu.access.agreements': '交换约定',
  'menu.access.channels': '接入通道',
  'menu.access.connections': '连接',
  'menu.access.profiles': '本方协议',
  'menu.access.certificates': '证书与密钥',

  'menu.standards': '报文标准',
  'menu.standards.library': '报文标准库',
  'menu.standards.standardDetail': '标准详情与结构编辑',
  'menu.standards.dictionaries': '码值字典',
  'menu.standards.documents': '业务单据',
  'menu.standards.documentDetail': '业务单据结构',
  'menu.standards.mapping': '映射',
  'menu.standards.mappingDesigner': '映射设计器',

  'menu.workflow': '工作流',
  'menu.workflow.detail': '工作流详情',
  'menu.workflow.flows': '业务流程',
  'menu.workflow.connections': '业务系统连接',

  'menu.messages': '报文中心',
  'menu.messages.query': '报文查询',
  'menu.messages.interchanges': '交换记录',
  'menu.messages.documents': '单号追溯',
  'menu.messages.batch': '批量报文处理',
  'menu.messages.archive': '归档与存储',
  'menu.messages.detail': '报文详情',

  'menu.alerts': '监控预警',
  'menu.alerts.events': '预警事件',
  'menu.alerts.rules': '预警规则',
  'menu.alerts.workorders': '异常工单',
  'menu.alerts.knowledge': '处理知识库',

  'menu.simulator': '模拟工具',
  'menu.simulator.mock': '收发模拟',
  'menu.simulator.diagnose': '报文诊断',

  'menu.audit': '审计合规',
  'menu.audit.logs': '操作审计',
  'menu.audit.reports': '审计报表',

  // 个人与系统辅助
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.workbench': '回到工作台',
  'menu.account.tenantManagement': '企业管理',
  'menu.account.logout': '退出登录',
};
